// @flow

import React, { Fragment } from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import { Heading, Button, Paragraph, MediaQuery } from '@riseart/common';
import { Section, Wrapper } from '@riseart/layout';
import { CmsModuleBanner } from 'shared_components/cms/modules/banner/Banner';
import HOCQuizRouteButton from 'shared_hocs/quiz/QuizRouteButton';
import { raScreenXsMax } from '@riseart/antd-provider/dist/website/variables.less';
import {
  quizStartContentCls,
  quizStartButtonCls,
} from 'shared_components/cms/modules/quiz/Start.less';

const RouteButton = HOCQuizRouteButton(Button);

type Props = {
  banner: Object,
  title: string,
  content: {
    title: string,
    text: Array<string>,
  },
  button: {
    text: string,
    link: string,
  },
  handleExpand: Function,
};

/**
 * CmsModuleQuizStart
 */
export const CmsModuleQuizStart = ({ banner, button, content = {}, title }: Props): Node => (
  <MediaQuery maxWidth={raScreenXsMax}>
    {(isPhone) => (
      <Fragment>
        <CmsModuleBanner
          {...(isPhone
            ? {
                title,
                customButton: (
                  <RouteButton type="ghost" href={button.link} title={button.text} trackData="main">
                    {button.text}
                  </RouteButton>
                ),
              }
            : null)}
          {...banner}
        />
        <Section className={quizStartContentCls}>
          <Wrapper>
            {!isPhone && button ? (
              <div className={quizStartButtonCls}>
                <RouteButton type="primary" href={button.link} title={button.text} trackData="main">
                  {button.text}
                </RouteButton>
              </div>
            ) : null}
            {!isPhone && title ? (
              <Heading tag="h2" level="2" align="center">
                {title}
              </Heading>
            ) : null}
            {content && content.title ? (
              <Heading tag="h3" level="3" align="center">
                {content.title}
              </Heading>
            ) : null}
            {content && content.text
              ? content.text.map((row, i) => <Paragraph key={i}>{row}</Paragraph>)
              : null}
            {button ? (
              <div className={quizStartButtonCls}>
                <RouteButton type="primary" href={button.link} title={button.text} trackData="main">
                  <FormattedMessage id="components.quiz.discover_your_personality" />
                </RouteButton>
              </div>
            ) : null}
          </Wrapper>
        </Section>
      </Fragment>
    )}
  </MediaQuery>
);
